<template>
<div>
  <div class="search-wrap">
    <el-button size="mini" @click="restore()">选中恢复</el-button>
    <el-button size="mini" @click="restoreAll()">全部恢复</el-button>
  </div>
  <div>
    <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
      <el-descriptions-item label="项目房产">
        {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
        <el-switch v-model="where.is_project" active-color="#13ce66" inactive-color="#ff4949" active-value="1" inactive-value="0" @change="pageChange(1)"></el-switch>
      </el-descriptions-item>
      <el-descriptions-item label="仪表ID">
        <el-input size="mini" placeholder="仪表ID" v-model="where.meter_id" clearable @change="pageChange(1)"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表编号">
        <el-input size="mini" placeholder="仪表编号" v-model="where.number" clearable @change="pageChange(1)"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表名称">
        <el-input size="mini" placeholder="仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表类型">
        <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable clearable placeholder="仪表类型" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="能耗类型">
        <el-select size="mini" style="width: 100%" v-model="where.energy" filterable clearable placeholder="仪表类型" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in energy_list" :key="item.val" :label="item.name" :value="item.val"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="操作方式">
        <el-select size="mini" style="width: 100%" v-model="where.cz_type" filterable clearable placeholder="操作方式" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in cz_type_list" :key="item.val" :label="item.name" :value="item.val"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="操作时间">
        <el-row>
          <el-col :span="11">
            <el-date-picker style="width: 100%" size="mini" type="datetime" placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" v-model="where.start_time" @change="pageChange(1)"></el-date-picker>
          </el-col>
          <el-col :span="2">
            <div style="text-align: center;margin-top: 5px;">至</div>
          </el-col>
          <el-col :span="11">
            <el-date-picker style="width: 100%" size="mini" type="datetime" placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" v-model="where.end_time" @change="pageChange(1)"></el-date-picker>
          </el-col>
        </el-row>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div>
    <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="60vh" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="id" width="80" fixed="left"></el-table-column>
      <el-table-column prop="number" label="仪表编号" width="150" fixed="left"></el-table-column>
      <el-table-column prop="name" label="仪表名称 " width="200"></el-table-column>

      <el-table-column prop="log_time" label="操作时间"  width="140"></el-table-column>
      <el-table-column prop="cz_type" label="操作方式"  width="90">
        <template slot-scope="scope">
          <span style="color: #ff0000;">{{cz_type_obj[scope.row.cz_type]}}</span>
        </template>
      </el-table-column>

      <el-table-column label="仪表类型" width="100">
        <template slot-scope="scope">
          {{listToidByName(meter_type_list,scope.row.meter_type)}}
        </template>
      </el-table-column>
      <el-table-column label="能耗类型" width="100">
        <template slot-scope="scope">
          {{energy_obj[scope.row.energy]}}
        </template>
      </el-table-column>
      <el-table-column prop="meter_level" label="仪表等级" width="100"></el-table-column>
      <el-table-column prop="house_name" label="所属房产" width="320"></el-table-column>
      <el-table-column prop="magnification" label="倍率" width="100"></el-table-column>

      <el-table-column prop="parent_number" label="上级表" width="120"></el-table-column>
      <el-table-column prop="remarks" label="备注" width="120"></el-table-column>
      <el-table-column prop="admin_name" label="操作人 " width="120"></el-table-column>
      <el-table-column prop="task_id" label="流程ID " width="120"></el-table-column>
      <el-table-column label="操作 " width="120" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" icon="el-icon-edit" @click="restore(scope.row)">恢复</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div style="margin-top: 20px;text-align: center;margin-right: 20px;">
    <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
  </div>



</div>
</template>

<script>
import MeterHttp from "../../common/MeterHttp";
import {CommonHelp} from "../../common/CommonHelp";
export default {
  name: "MeterLogList",
  inject:['mainObj','componentId','setComponentId'],
  components:{},
  data(){
    return{
      where:{
        meter_id:"",
        number:"",
        name:"",
        meter_type:"",
        is_project:"1",
        start_time:"",
        end_time:"",
        cz_type:""
      },
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 50,
        page: 1
      },
      multipleSelection: [],
      meter_type_list:[],
      status_list:[{id:0,name:'停用'},{id:1,name:'启用'}],
      cz_type_list:[{name:'新增',val:'add'},{name:'修改',val:'update'},{name:'删除',val:'delete'}],
      cz_type_obj:{
        add:'新增',
        update:'修改',
        delete:'删除'
      },
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3}],
      energy_obj:{
        1:"业主能耗",
        2:"物业能耗",
        3:"分摊能耗"
      }
    }
  },
  mounted() {
    this.getMeterTypeList();
    this.mainObj.project_id&&this.pageChange(1);
  },
  methods:{
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChange(i){
      const that = this;
      this.pageData.page = i
      CommonHelp.debounce(function () {
        that.getList()
      }, 500,that)

    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      MeterHttp.post("MeterLog/index",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res=>{
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      })
    },
    reNumber(x){
      return Math.floor(x*100)/100
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    listToidByName(list,id){
      let index=list.findIndex(ret=>ret.id===id)
      return (list[index]||{}).name
    },
    restore(item=null){
      const that = this;
      if(item){
        this.multipleSelection=[item];
      }
      let ids = this.multipleSelection.map(ret=>ret._id);
      if(ids.length===0){
        this.$message.error("请选择要恢复的记录");
        return;
      }
      this.$confirm('确认恢复所选记录吗？').then(() => {
        that.loading = true;
        MeterHttp.post("MeterLog/restore",{
          ids:ids.join(","),
          user_type:(that.$route.query.type||0)
        },ret=>{
          if(ret.code){
            that.$message.success("恢复成功");
            that.getList();
          }else{
            that.$message.error(ret.msg);
          }
          that.loading = false;
        })
      }).catch(() => {
        that.$message.info('已取消')
      })
    },
    restoreAll(){
      const that = this;
      this.$confirm('确认恢复全部记录吗？').then(() => {
        that.loading = true;
        MeterHttp.post("MeterLog/restoreAll",{
          project_id:that.mainObj.project_id,
          user_type:(that.$route.query.type||0)
        },ret=>{
          if(ret.code){
            that.$message.success("恢复成功");
            that.getList();
          }else{
            that.$message.error(ret.msg);
          }
          that.loading = false;
        })
      }).catch(() => {
        that.$message.info('已取消')
      })
    },
  },
  watch:{
    'mainObj.project_id':function (newVal,oldVal){
      if(newVal){
        this.pageChange(1);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_log/MeterLogList.vue